import { get } from './get';
import { post } from './post';

export const uploads = {
  get,
  post,
};
